import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {ProviderModel} from '../../../../models/ProviderModel';
import {RegionModel} from '../../../../models/RegionModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {TerminationFeeService} from '../service-termination-fee/termination-fee.service';
import {TerminationFeeModel} from '../../../../models/TerminationFeeModel';
import * as toastr from 'toastr';
import { ServiceVariantModel } from 'src/models/ServiceVariantModel';

@Component({
  selector: 'app-edit-termination-fee',
  templateUrl: './edit-termination-fee.component.html',
  styleUrls: ['./edit-termination-fee.component.scss']
})
export class EditTerminationFeeComponent extends BaseGeneralComponent implements OnInit, OnDestroy {
  showActions: boolean;

  terminationFee: TerminationFeeModel;
  providerSelect: ProviderModel;
  regionSelect: RegionModel;
  localCustomerSelect: LocalCustomerModel;
  contractTypeSelect: ContractTypeModel;
  resourceUnitSelect: ServiceVariantModel;
  currencySelect: CurrencyModel;
  terminationFeeSelect: number;

  selected: string;
  saveterminationFee: Subscription;
  parameterSubscribe: Subscription;

  registerForm: FormGroup;
  submitted = false;
  terminationFeeJson: any;

  getPageSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private terminationFeeService: TerminationFeeService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService) {
    super();


    this.terminationFee = new TerminationFeeModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.providerSelect = new ProviderModel();
    this.contractTypeSelect = new ContractTypeModel();
    this.resourceUnitSelect = new ServiceVariantModel();
    this.currencySelect = new CurrencyModel();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.terminationFeeJson = params['row'];
        this.terminationFee = JSON.parse(this.terminationFeeJson) as TerminationFeeModel;
        this.localCustomerSelect = this.terminationFee.localCustomer;
        this.regionSelect = this.terminationFee.region;
        this.providerSelect = this.terminationFee.provider;
        this.contractTypeSelect = this.terminationFee.contractType;
        this.resourceUnitSelect = this.terminationFee.serviceVariant;
        this.currencySelect = this.terminationFee.currency;
        this.terminationFeeSelect = this.terminationFee.terminationFee
      });


    this.registerForm = this.formBuilder.group({
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      contractType: [{value: '', disabled: false}, Validators.required],
      currency: [{value: '', disabled: false}, Validators.required],
      resourceUnit: [{value: '', disabled: false}, Validators.required],
      terminationFee: [{value: '', disabled: false}, Validators.required]

    });

    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });

    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });

    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });

    this.registerForm.patchValue({
      contractType: this.contractTypeSelect.cod
    });

    this.registerForm.patchValue({
      currency: this.currencySelect.cod
    });

    this.registerForm.patchValue({
      resourceUnit: this.resourceUnitSelect.cod
    });

    this.registerForm.patchValue({
      terminationFee: this.terminationFeeSelect
    });

  }
  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 2}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.loaderService.display(true);
      this.terminationFee.terminationFee = this.registerForm.value.terminationFee;
      this.saveterminationFee = this.terminationFeeService.update(this.terminationFeeService.baseUrl, this.terminationFee)
        .subscribe(
          (result: any) => {
            toastr.success('Termination Fee element was edited with success', 'Success');
            this.loaderService.display(false);
            this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 2}});
          },
          error => {
            toastr.error('Termination Fee element was not edited', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveterminationFee) {
      this.saveterminationFee.unsubscribe();
    }
    if (this.parameterSubscribe) {
      this.parameterSubscribe.unsubscribe();
    }
  }
  /*
    getElementSelectedLC($event) {
      this.reimbursment.localCustomer = $event.row;
      this.localCustomerSelect = $event.row;
      this.registerForm.patchValue({
        localCustomerCod: this.localCustomerSelect.cod
      });
    }

    getElementSelectedRegion($event) {
      this.reimbursment.region = $event.row;
      this.regionSelect = $event.row;
      this.registerForm.patchValue({
        region: this.regionSelect.cod
      });
    }

    getElementSelectedProvider($event) {
      this.reimbursment.provider = $event.row;
      this.providerSelect = $event.row;
      this.registerForm.patchValue({
        provider: this.providerSelect.cod
      });
    }

    getElementSelectedContractType($event) {
      this.reimbursment.contractType = $event.row;
      this.contractTypeSelect = $event.row;
      this.registerForm.patchValue({
        contractType: this.contractTypeSelect.cod
      });
    }

    getElementSelectedResourceUnit($event) {
      this.reimbursment.resourceUnit = $event.row;
      this.resourceUnitSelect = $event.row;
      this.registerForm.patchValue({
        resourceUnit: this.resourceUnitSelect.cod
      });
    }

    getElementSelectedCurrency($event) {
      this.reimbursment.currency = $event.row;
      this.currencySelect = $event.row;
      this.registerForm.patchValue({
        currency: this.currencySelect.cod
      });
    }

  */
  handle(value) {
    this.terminationFee.terminationFee = value;
    this.registerForm.patchValue({
      terminationFee: value
    });
  }
  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }


}

